module.exports = __webpack_public_path__ + "static/media/img_inbox.01d8ec6e.svg";